import axiosTokenInstance from "services/api/backoffice";
import {
    MY_SALES_DETAILS_EXECUTIVE,
    MY_SALES_DETAILS_EXECUTIVE_ERROR,
} from "_models/redux/types";

// Action function
export const getMySalesExecutiveDetails = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/callcenter/reports/sales/details?date=${params.date}`
        );

        const { data, status } = response || {};

        dispatch({
            type: MY_SALES_DETAILS_EXECUTIVE,
            payload: data || {},
            status: status || {},
            method: "get",
        });
    } catch (e) {
        dispatch({
            type: MY_SALES_DETAILS_EXECUTIVE_ERROR,
            payload: e || {},
        });
    }
};
